module.exports = {"id":"162890","name":"Jonathan Spector","rating":"72","photo":"./data/images/photos/1/162890.png","club":{"name":"Orlando City","logo":"./data/images/clubs/OrlandoCity.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JonathanSpector0.json
// module id = 2111
// module chunks = 0